import PropTypes       from '../PropTypes';
import React           from 'react';
import styles          from './styles.module.scss';
import Link            from '../Link';
import Icon            from '../Icon';
import IconType        from '../Icon/IconType';
import IconButtonTheme from './IconButtonTheme';
import classNames      from 'classnames';
import SelectionHelper from '../../helper/SelectionHelper';
import ComponentHelper from '../../helper/ComponentHelper';

class IconButton extends React.Component {
    getClassName = () => {
        const className = classNames(
            styles.iconButton,
            SelectionHelper.get(
                this.props.theme,
                {
                    [IconButtonTheme.bigIcon]:     styles.iconButtonBigIcon,
                    [IconButtonTheme.grayRounded]: styles.iconButtonGrayRounded,
                    [IconButtonTheme.redRounded]:  styles.iconButtonRedRounded,
                },
            ),
        );

        return className;
    };

    render () {
        const finalClassName = this.getClassName();
        const icon           = this.renderIcon();

        if (this.props.onClick) {
            return (
                <div
                    className={finalClassName}
                    onClick={this.props.onClick}
                    title={this.props.title}
                >
                    {icon}
                </div>
            );
        } else if (this.props.to) {
            return (
                <Link
                    className={finalClassName}
                    title={this.props.title}
                    to={this.props.to}
                >
                    {icon}
                </Link>
            );
        }

        return null;
    }

    renderIcon = () => {
        return (
            <Icon iconType={this.props.iconType} />
        );
    };

    shouldComponentUpdate (nextProps, nextState) {
        return ComponentHelper.shouldComponentUpdate(
            this,
            Component,
            nextProps,
            nextState,
        );
    }
}

const Component = IconButton;

Component.propTypes = {
    iconType: PropTypes.oneOf(Object.values(IconType)),
    onClick:  PropTypes.func,
    theme:    PropTypes.oneOf(Object.values(IconButtonTheme)),
    title:    PropTypes.string,
    to:       PropTypes.string,
};

Component.defaultProps = {
    iconType: null,
    onClick:  null,
    theme:    null,
    title:    null,
    to:       null,
};

Component.renderAffectingProps = [
    'iconType',
];

Component.renderAffectingStates = [];

export default Component;